export default {
	name: 'ProductsView'
}